import React from 'react';
import 'aos/dist/aos.css';

const MissionVision = () => {
  return (
    <div className="mx-auto px-4 m-4 py-12 container bg-[#13689b]">
      <div className="flex flex-col gap-8">
        <div className="p-6 bg-[#13689b] rounded-lg flex flex-col items-center">
          <h3 className="text-2xl font-semibold mb-2 text-white">Vision Statement</h3>
          <p className="text-white mb-4 text-justify">
          We aim to be the premier global business solutions provider, known for our innovation and commitment to fostering sustainable growth for businesses everywhere.
          </p>
        </div>
        <div className="p-6 bg-[#13689b] rounded-lg flex flex-col">
          <h3 className="text-2xl font-semibold mb-2 text-white">Mission Statement</h3>
          <p className="text-white text-justify">
          At WHYME Solutions, our mission is to deliver innovative business solutions that drive growth and efficiency for our diverse clients. We leverage cutting-edge technology and core competencies, while fostering a culture of transparency, integrity, and collaboration. We are dedicated to driving profitability while upholding social responsibility, ensuring a positive and lasting impact on both our clients and the communities we serve. Our team, our greatest asset, is committed to excellence, creating long-term value and success for businesses worldwide.

          </p>
        </div>
      </div>
    </div>
  );
};

export default MissionVision;
